import { render, staticRenderFns } from "./Massas.vue?vue&type=template&id=e5cdabfa"
import script from "./Massas.vue?vue&type=script&lang=js"
export * from "./Massas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports